import { createStore } from 'zustand'

import { FormMode } from '@eastcoal/formily/components/CrudForm/enums/FormMode'

import { AuctionListStore, AuctionListStoreOptions } from './interface'

export const createAuctionListStore = ({
  tableRef,
  previewRef
}: AuctionListStoreOptions) =>
  createStore<AuctionListStore>((set, get) => ({
    tableRef,
    previewRef,
    currentAuction: undefined,
    setCurrentAuction(auction) {
      set({ currentAuction: auction })
    },
    detailFormMode: FormMode.READ,
    setDetailFormMode(mode) {
      set({ detailFormMode: mode })
    },
    detailFormVisible: false,
    toggleDetailFormVisible(visible) {
      const { detailFormVisible, setDetailFormMode, setCurrentAuction } = get()
      const newVisible = visible ?? !detailFormVisible

      set({ detailFormVisible: newVisible })

      if (!newVisible) {
        setDetailFormMode(FormMode.READ)
        setCurrentAuction({})
      }
    },
    bidMemberListModalVisible: false,
    toggleBidMemberListModalVisible(visible) {
      set(state => ({
        bidMemberListModalVisible: visible ?? !state.bidMemberListModalVisible
      }))
    },
    bidRecordListModalVisible: false,
    toggleBidRecordListModalVisible(visible) {
      set(state => ({
        bidRecordListModalVisible: visible ?? !state.bidRecordListModalVisible
      }))
    },
    haltFormVisible: false,
    toggleHaltFormVisible(visible) {
      set(state => ({
        haltFormVisible: visible ?? !state.haltFormVisible
      }))
    },
    dealNoticeBatchDownloadModalVisible: false,
    toggleDealNoticeBatchDownloadModalVisible(visible) {
      set(state => ({
        dealNoticeBatchDownloadModalVisible:
          visible ?? !state.dealNoticeBatchDownloadModalVisible
      }))
    }
  }))
